import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB8y6xR07awwmzJqwCw3pu4GbSjWhlzBic",
    authDomain: "automaxspace.com",
    projectId: "automax-d9c13",
    storageBucket: "automax-d9c13.firebasestorage.app",
    messagingSenderId: "291040078325",
    appId: "1:291040078325:web:d577972aece56d963f98bc",
    measurementId: "G-E8K0WPK39J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Storage
export const storage = getStorage(app);

// Initialize Analytics (only in production)
let analytics;
if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
}

export { analytics };
